import { SuperSpaceUserService } from "../../../services/superSpaceUser/superSpaceUser.service";
const _superSpaceUserService = new SuperSpaceUserService();

const enableSuperSpaceUserAction = (
  { commit },
  { superSpaceUserId, data, callback, callbackError }
): void => {
  _superSpaceUserService
    .enableSuperSpaceUser(superSpaceUserId, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const changeSuperSpaceUserPermissionsAction = (
  { commit },
  { superSpaceUserId, data, callback }
): void => {
  _superSpaceUserService
    .updateSuperSpaceUserPermissions(superSpaceUserId, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const changeCollectionSuperSpaceUserPermissionsAction = (
  { commit },
  { data, callback }
) => {
  _superSpaceUserService
    .updateCollectionSuperSpaceUserPermissions(data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};
const deleteSuperSpaceUserAction = (
  { commit },
  { superSpaceUserId, callback }
): void => {
  _superSpaceUserService
    .deleteSuperSpaceUser(superSpaceUserId)
    .then(() => {
      callback();
    })
    .catch((error) => {
      console.log(error);
    });
};

const getSuperSpaceUsersAction = (
  { commit },
  {
    superSpaceId,
    page,
    itemsPerPage = 30,
    search,
    permissions,
    callback,
    callbackError,
  }
) => {
  _superSpaceUserService
    .getSuperSpaceUsers(superSpaceId, page, itemsPerPage, search, permissions)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const changeSuperSpaceUserHostPermissionsAction = (
  { commit },
  { superSpaceUserId, data, callback }
): void => {
  _superSpaceUserService
    .updateSuperSpaceUserHostPermissions(superSpaceUserId, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

export default {
  enableSuperSpaceUserAction,
  changeSuperSpaceUserPermissionsAction,
  deleteSuperSpaceUserAction,
  changeCollectionSuperSpaceUserPermissionsAction,
  getSuperSpaceUsersAction,
  changeSuperSpaceUserHostPermissionsAction,
};
